import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";

import { FilterForm } from "../inspections/filters/filter-form-interface";

@Injectable({
  providedIn: "root",
})
export class InspectionFilterService {
  public constructor(private readonly httpService: HttpService) {}

  public filterForm: FilterForm = {
    status: "",
    origin: "",
    type: "",
    inspectionId: "",
    client: "",
    inspectionReference: "",
    dateFrom: "",
    dateTo: "",
    creationDateFrom: "",
    creationDateTo: "",
    closeDate: "",
    vesselName: "",
    timeManagementState: "",
  };

  public filterIsOpen: boolean;

  public getFilterForm(): FilterForm {
    return this.filterForm;
  }

  public setFilterForm(filterForm: FilterForm): void {
    this.filterForm = filterForm;
  }

  public getEmptyFilter(): FilterForm {
    this.filterForm = {
      status: "",
      origin: "",
      type: "",
      inspectionId: "",
      client: "",
      inspectionReference: "",
      dateFrom: "",
      dateTo: "",
      creationDateFrom: "",
      creationDateTo: "",
      closeDate: "",
      vesselName: "",
      timeManagementState: "",
    };
    return this.filterForm;
  }

  public setFilterStatus(filterIsOpen: boolean): void {
    this.filterIsOpen = filterIsOpen;
  }

  public getFilterStatus(): boolean {
    return this.filterIsOpen;
  }

  public getOrigins(): Promise<string[]> {
    return this.httpService
      .get(`${environment.webApiUrl}/api/inspection/origins`, {
        withCredentials: true,
      })
      .pipe(
        map((origins: []) => {
          return origins;
        }),
      )
      .toPromise();
  }
}
